module.exports = __webpack_public_path__ + "img/antes_despues_329.0b4a44d6.png";